<template>
  <div>
    <div id="func-content">
      <div class="row">
        <div class="col-lg-12">
          <div class="p-4 box-shadow">
            <div class="row mt-3">
              <label class="control-label col-md-2">品牌：</label>
              <div class="col-md-3">
                <select class="form-control" v-model="memoBrandCode" @change="loadPaymentMemo">
                  <option v-for="x in selectListBrands" :value="x.Code" :key="'memo_'+x.Code" :disabled="!x.Code">{{x.Text}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-lg-12">
          <div class="table-responsive">
            <table class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th style="width:25%">支付方式</th>
                  <th>備註</th>
                </tr>
              </thead>
              <tbody>
                <!-- 信用卡 (paymentMethod=1) 不在此頁面顯示，但 API 仍會回傳 + 儲存時保留原值 -->
                <tr v-for="m in displayedPaymentMemos" :key="'pm_'+m.paymentMethod">
                  <td>{{m.paymentName}}</td>
                  <td>
                    <input type="text" class="form-control" v-model.trim="m.memo"
                           :maxlength="30" placeholder="字數建議10字以內"
                           :disabled="FunctionPermission < 2">
                  </td>
                </tr>
                <tr v-if="displayedPaymentMemos.length === 0">
                  <td colspan="2" class="text-center text-muted">請選擇品牌</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-lg-12 text-right" v-if="FunctionPermission >= 2 && displayedPaymentMemos.length > 0">
          <b-btn variant="primary" @click="paymentMemoConfirmShow">儲存</b-btn>&nbsp;
          <b-btn variant="secondary" @click="loadPaymentMemo">重設</b-btn>
        </div>
      </div>

      <!-- 確認儲存 Modal -->
      <b-modal ref="mdMemoCheck" hide-footer title="支付方式備註修改">
        <b-container fluid>
          <div class="row mb-3">
            <label class="control-label">確定要儲存此品牌的支付方式備註嗎？</label>
          </div>
          <div class="float-right">
            <b-btn variant="primary" @click="savePaymentMemo">確定</b-btn>
            <b-btn variant="secondary" @click="$refs.mdMemoCheck.hide()">取消</b-btn>
          </div>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import { API_URL } from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import axios from 'axios'
miniToastr.init()

export default {
  data () {
    return {
      FunctionPermission: 0,
      memoBrandCode: '',
      paymentMemos: [],          // [{paymentMethod, paymentName, memo}] — 完整清單 (含 API 回傳的所有支付方式)
      selectListBrands: [{ ID: 0, Code: '', Text: '全部' }],
      API_URL: API_URL
    }
  },
  computed: {
    // 頁面實際顯示的支付方式 — 信用卡 (paymentMethod=1) 不在此編輯，
    // 但 API 仍回傳、儲存時保留原值，不影響資料完整性
    displayedPaymentMemos () {
      return this.paymentMemos.filter(m => m.paymentMethod !== 1)
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F39') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    this.querySelectListBrands()
  },
  methods: {
    querySelectListBrands () {
      this.$parent.Loading = true
      axios.post(API_URL + '/web/brands/v1', {
        all: false,
        order: true
      })
        .then((response) => {
          this.selectListBrands = response.data.data
          this.$parent.Loading = false
          // 預設選第一個 Code 非空的品牌並載入備註
          if (!this.memoBrandCode && this.selectListBrands.length > 0) {
            const firstBrand = this.selectListBrands.find(b => b.Code)
            if (firstBrand) {
              this.memoBrandCode = firstBrand.Code
              this.loadPaymentMemo()
            }
          }
        })
        .catch((error) => {
          this.selectListBrands = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    loadPaymentMemo () {
      if (!this.memoBrandCode) {
        this.paymentMemos = []
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getpaymentmemo/v1', {
        brandCode: this.memoBrandCode
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false
          if (response.data.result === '0000') {
            this.paymentMemos = response.data.data || []
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.paymentMemos = []
            miniToastr.error(response.data.message, '資料讀取異常')
          }
        })
        .catch((error) => {
          this.paymentMemos = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    paymentMemoConfirmShow () {
      if (this.FunctionPermission < 2) return
      // 字數檢查 (UI 建議 10 字內，DB 上限 30 字)
      // 只驗證目前頁面顯示的項目 (信用卡略過)
      const tooLong = this.displayedPaymentMemos.find(m => (m.memo || '').length > 30)
      if (tooLong) {
        miniToastr.error(`「${tooLong.paymentName}」備註字數超過上限 (30字)`, '資料驗證錯誤')
        return
      }
      this.$refs.mdMemoCheck.show()
    },
    savePaymentMemo () {
      this.$refs.mdMemoCheck.hide()
      if (this.FunctionPermission < 2) return
      this.$parent.Loading = true
      const items = this.paymentMemos.map(m => ({
        paymentMethod: m.paymentMethod,
        memo: m.memo || ''
      }))
      return axios.post(API_URL + '/web/shopping/updatepaymentmemo/v1', {
        brandCode: this.memoBrandCode,
        items: items
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false
          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.loadPaymentMemo()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/store/PaymentMemo.vue